import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Button } from '@blueprintnyc/bpnyc-common-admin';
import ImageCard from 'components/ImageCard';
import EventStatusIndicator from 'components/EventStatusIndicator';
import { hasSomeRoleInEvent } from '@/redux/util';

import './EventListItem.scss';

const EventListItem = props => {
	const { event, auth0Token, socket } = props;
	const navigate = useNavigate();
	if (!hasSomeRoleInEvent(event)) {
		return null;
	}
	const inputFormat = moment.ISO_8601;
	const outputFormat = 'MM/DD/YYYY';
	const startTime = moment(event.start_time, inputFormat).format(outputFormat);
	const endTime = moment(event.end_time, inputFormat).format(outputFormat);
	const lastUpdated = moment(event.updated_at, inputFormat).fromNow();
	const archivedTime = moment(event.deleted_at, inputFormat).calendar();
	const archivedClass = event.deleted_at ? ' archived' : '';

	const handleUndelete = () => {
		socket.emit('event/:eventID/undelete/PATCH', event, auth0Token);
	};

	const navigateTo = path => e => {
		e.preventDefault();
		navigateTo(path);
	};

	const Unarchive = () => {
		return event.deleted_at ? (
			<div className="archive-data">
				<Button ghost onClick={handleUndelete}>
					Unarchive
				</Button>
				<div className="archive-text">Archived: {archivedTime}</div>
			</div>
		) : null;
	};

	return (
		<ImageCard
			className={`EventListItem ${archivedClass}`}
			onClick={() => navigate(`/events/${event.id}/dashboard`)}
			image={event.event_image_url}
			title={
				<div className="first-row">
					<div className="title">{event.name}</div>
					<EventStatusIndicator status={event.status} />
				</div>
			}
			responsive={true}
		>
			<div className="start-time">{startTime}</div>
			<div className="time">{`${startTime} - ${endTime}`}</div>
			<div className="location">{event.location}</div>
			<Unarchive />
			<div className="updated">
				Last updated
				<br />
				{lastUpdated}
			</div>
			<div className="last-updated">Last updated {lastUpdated}</div>
		</ImageCard>
	);
};

export default EventListItem;
